import { render, staticRenderFns } from "./VerandaPanelMaterials.vue?vue&type=template&id=ae685dee"
import script from "./VerandaPanelMaterials.vue?vue&type=script&lang=ts"
export * from "./VerandaPanelMaterials.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports